
export const plantRotationAlgorithm = async (ctx) => {

}